import * as React from 'react';
import { useState } from 'react';

import * as analytics from '@opendoor/shared-fe/build/analytics';
import { Box, Button, Flex, Text } from '@opendoor/bricks/core';

import { SellerInputAddress } from 'src/store/sellerInput';

import AddressModal from './AddressModal';

interface IProps {
  address: SellerInputAddress;
  goToManualAddressVerificationPage?: () => void;
}

const AddressBar: React.FC<IProps> = ({ address, goToManualAddressVerificationPage }) => {
  const [isAddressModalOpen, setAddressModalOpen] = useState(false);
  const handleModalOpen = () => {
    analytics.trackEvent('modify-address', 'not-your-address', 'open');
    setAddressModalOpen(true);
  };
  const handleModalClose = () => {
    analytics.trackEvent('modify-address', 'not-your-address', 'close');
    setAddressModalOpen(false);
  };
  return (
    // TODO @growth investigate if this theme provider is redundant
    <Flex alignItems="center" justifyContent="flex-start" mb={[7, 0]} id="not-your-address">
      <Box pr={6}>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Text fontSize="s1" lineHeight="s0" color="neutrals100">
          {address.street}
        </Text>
      </Box>
      <Button
        onClick={handleModalOpen}
        fontSize="s1"
        color="brand50"
        fontWeight="bold"
        analyticsName="reception-fe-edit-address"
        aria-label={'Edit your address'}
        variant="link"
        p={0}
        m={0}
        height="unset"
        width="unset"
      >
        Edit
      </Button>
      <AddressModal
        isOpen={isAddressModalOpen}
        onRequestClose={handleModalClose}
        address={address}
        goToManualAddressVerificationPage={goToManualAddressVerificationPage}
      />
    </Flex>
  );
};

export default AddressBar;
